import * as React from 'react';
import { observer } from 'mobx-react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { adopt } from 'react-adopt';
import { buildNavLinkUrl } from '../../helpers/categories/buildNavLinkUrl';
import { FlashMessage, IconButton } from '../../modules/modules';
import FlashStore from '../../services/FlashStore';
import Categories from '../Query/Categories/Categories';
import Banners from '../Query/Banners/Banners';
import Hamburger from './components/Hamburger';
import Country from './components/Country';
import CountryService from '../../services/CountryService';
import Account from './components/Account';
import HeaderLink from './components/Link';
import Search from './components/Search';
import NoticeBar from './components/NoticeBar';
import { IHeaderParams } from './types';
import { baseUrl, imgUrl } from '../../config';

const HeaderParams = adopt({
  categories: <Categories />,
  banners: <Banners />,
});

interface IHeaderProps extends RouteComponentProps<{ language: string }> {
  cart?: boolean;
  navData?: any;
}

interface IHeaderState {
  modals: any;
  navbar: boolean;
  showDropdown: boolean;
  isSticky: boolean;
  menuActive: boolean;
  subMenuVisible: string;
  navData: any;
  navProducts: any;
  phoneSubMenuVisible: string;
}

@observer
class Header extends React.Component<IHeaderProps, IHeaderState> {
  public headerWrapper: any;

  constructor(props: IHeaderProps) {
    super(props);

    this.headerWrapper = React.createRef();

    const nav = props.navData ? props.navData.find((d: any) => d.name === 'top') : [];

    this.state = {
      modals: {
        login: false,
        search: false,
      },
      navbar: false,
      showDropdown: false,
      isSticky: false,
      menuActive: false,
      subMenuVisible: '',
      navData: nav && nav.nodes ? [...nav.nodes] : [],
      navProducts: [],
      phoneSubMenuVisible: '',
    };

    // this.toggleNavbar = this.toggleNavbar.bind(this);
    // this.stickyRef = this.stickyRef.bind(this);
  }

  public componentDidMount() {
    this.setState({
      navProducts: require('./topProducts.json'),
    });
  }

  // public stickyRef(el: any) {
  //   if (el) {
  //     window.addEventListener('scroll', () => {
  //       const doc = document.documentElement;
  //       const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

  //       if (scrollTop > el.offsetTop + el.offsetHeight) {
  //         if (!this.state.isSticky) {
  //           this.setState({ isSticky: true });
  //         }
  //       } else {
  //         if (this.state.isSticky) {
  //           this.setState({ isSticky: false });
  //         }
  //       }
  //     });
  //   }
  // }

  public toggleModal(modal: string, open?: boolean) {
    if (open === undefined) {
      open = !this.state.modals[modal];
    }

    this.setState({ modals: { ...this.state.modals, [modal]: open } });
  }

  hideSubMenu = () => {
    this.setState({ subMenuVisible: '' });
  }

  submenuVisibility = (name: any) => {
    this.setState({ subMenuVisible: name });
    this.setState({ phoneSubMenuVisible: name });
  }

  public replaceHistory(e: any, target: string) {
    e.preventDefault();
    this.props.history.replace(target);
  }

  public toggleDropdown = () => {
    this.setState({ showDropdown: !this.state.showDropdown });
  }

  public canToggle = (item: any) => {
    return item.children ? '#' : item.url.url;
  }

  public componentWillReceiveProps(nextProps: IHeaderProps) {
    if (nextProps.navData) {
      const nav = nextProps.navData ? nextProps.navData.find((d: any) => d.name === 'top') : [];
      this.setState({
        navData: nav && nav.nodes ? [...nav.nodes] : [],
      });
    }
  }

  public render() {
    const { language, countryCode } = CountryService.GetInstance();
    const flashMessage = FlashStore.GetInstance().getMessage;

    const url: string = baseUrl ? baseUrl : window && window.location && window.location.origin;

    return (
      <React.Fragment>
        <Helmet>
          <title>{process.env.REACT_APP_PROJECT_NAME}</title>

          <meta name="copyright" content={process.env.REACT_APP_PROJECT_NAME} />
          <meta name="keywords" content={process.env.REACT_APP_PROJECT_KEYWORDS} />
          <meta name="description" content={process.env.REACT_APP_PROJECT_DESCRIPTION} />
          <meta name="robots" content="index, follow" />

          <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
          <link rel="shortcut icon" href="/favicon/favicon.ico" />

          <script
            type="text/javascript"
            src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
            async={true}
          />

          {/* <meta property="fb:app_id" content="?" /> */}

          {process.env.REACT_APP_GOOGLE_TAG_MANAGET_CODE && (
            <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${
              process.env.REACT_APP_GOOGLE_TAG_MANAGET_CODE
            }');`}</script>
          )}

          {/* <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-T35ZRJH');`}</script> */}
          {/* End Google Tag Manager */}

          <meta property="og:type" content="website" />
          <meta property="og:title" content={process.env.REACT_APP_PROJECT_NAME} />
          <meta property="og:description" content={process.env.REACT_APP_PROJECT_DESCRIPTION} />
          <meta property="og:url" content={url + this.props.location.pathname} />
          <meta property="og:image" content={`${imgUrl}/static/logo.png`} />
          <meta property="og:site_name" content={process.env.REACT_APP_PROJECT_NAME} />
        </Helmet>

        <FlashMessage type={flashMessage.type} visible={flashMessage.msg !== ''} link={flashMessage.link}>
          {flashMessage && flashMessage.msg}
        </FlashMessage>

        <HeaderParams>
          {({ categories, banners }: IHeaderParams) => {
            const banner =
              banners.banners && banners.banners.banners && banners.banners.banners.length > 0
                ? banners.banners.banners.find((b: any) => b.type === 'TopMessage')
                : null;

            return (
              <header className="header">
                <NoticeBar />
                <div className="container">
                  <div className="header__top nav--top">
                    <Account />
                    <Country />
                    <Hamburger active={this.state.menuActive} onClick={this.toggleMenu} />
                  </div>
                  <div className="header__main">
                    {/* Logo */}
                    <Link to={`/${countryCode}`} className="header__main__logo">
                      <img
                        className="header__main__logo__image"
                        src={'/assets/images/logo.svg'}
                        alt="Divesoft logo"
                      />
                    </Link>
                    <div className="header__main__wrapper">
                      <Search />
                      <IconButton
                        className="header__main__cart"
                        type="secondary"
                        icon="cart"
                        onClick={() => {
                          // Country code urls are not used anymore
                          // this.props.history.push(`/${countryCode}/cart`);
                          this.props.history.push(`/cart`);
                        }}
                      >
                        Cart
                      </IconButton>
                    </div>
                  </div>
                </div>
                <nav
                  className={`header__hiddenMenu ${
                    this.state.menuActive ? 'header__hiddenMenu--active' : ''
                  }`}
                >
                  <ul>
                    {categories &&
                      categories.categories &&
                      categories.categories.categories &&
                      this.renderCategoryMenu(categories.categories.categories)}
                  </ul>
                </nav>
              </header>
            );
          }}
        </HeaderParams>
      </React.Fragment>
    );
  }

  private webUrl = () => process.env.REACT_APP_WEB_URL;

  private renderNavigation = () => {
    if (this.state.navData) {
      return this.state.navData
        .filter((navItem: any) => navItem.parent === null)
        .map((navItem: any, i: number) => {
          // submenu
          const subNavItems = this.state.navData.filter((subNavItem: any) => {
            return navItem.page && subNavItem.parent === navItem.page.page;
          });

          const hasSubMenu = (navItem.page && navItem.page.name === 'products') || subNavItems.length > 0;

          return (
            <li key={i} style={{ position: 'relative' }}>
              <HeaderLink
                to={hasSubMenu ? null : navItem.page && navItem.page.url ? navItem.page.url : navItem.link}
              >
                <span className="d-flex no-wrap">
                  {(navItem.page && navItem.page.name) || navItem.title}
                  {hasSubMenu && <span onClick={() => this.toggleDropdown()} className={'dropdown__arrow'} />}
                </span>
              </HeaderLink>

              {subNavItems && !(navItem.page && navItem.page.name === 'products') && (
                <div className="categoriesSubmenu__wrapper" key={navItem.id} onMouseLeave={this.hideSubMenu}>
                  <nav className="categoriesSubmenu">
                    <ul className="categoriesSubmenu__list">
                      {subNavItems.map((navItemChild: any, j: number) => {
                        return (
                          <li key={j}>
                            <HeaderLink
                              to={
                                navItemChild.page && navItemChild.page.url
                                  ? navItemChild.page.url
                                  : navItemChild.link
                              }
                              className="categoriesSubmenu__link"
                            >
                              {(navItemChild.page && navItemChild.page.name) || navItemChild.title}
                            </HeaderLink>
                          </li>
                        );
                      })}
                    </ul>
                  </nav>
                </div>
              )}

              {navItem.page && navItem.page.name === 'products' && (
                <div className="dropdownProducts" onMouseLeave={this.hideSubMenu}>
                  {this.state.navProducts && (
                    <div className="container">
                      <div className="row productsPreview__list">
                        {this.state.navProducts.map((product: any, j: number) => (
                          <div key={j} className={'col-12 col-lg-6 col-xl-3'}>
                            <div className={'productsPreview__list__item'}>
                              {/* <Media type={'image'} data={item.img} /> */}
                              {/* <img src="https://fakeimg.pl/250x100/f3f3f3/" /> */}

                              {product.title && <h5>{product.title}</h5>}
                              {product.description && <p>{product.description}</p>}
                              <a href={product.url && `${this.webUrl()}${product.url.url}`} className="btn">
                                detail
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </li>
          );
        });
    }
  }

  private renderCategoryMenu = (categories: any) => {
    const { language, countryCode } = CountryService.GetInstance();

    if (categories) {
      return categories
        .filter((category: GQL.ICategory) => !category.parentCategoryId && category.priority <= 100)
        .map((category: GQL.ICategory, i: number) => (
          <li key={i} className="category">
            <img className="category__image" src={`/assets/images/${category.slug[language]}.svg`} />
            <Link to={buildNavLinkUrl(category.slug[language], countryCode)} onClick={() => this.closeMenu()}>
              {category.name[language]}
            </Link>
          </li>
        ));
    }

    return null;
  }

  private closeMenu = () => {
    this.setState({
      menuActive: false,
    });
  }

  private toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx